import cookie from "js-cookie";
import { AuthModel, PaymentStage } from "../contexts/Payment/payment.context";

export default function humanize(str) {
  return str.replace(/[-_]/g, " ");
}

export const RE_DIGIT = new RegExp(/^\d+$/);

export const chunkSubstr = (str, size) => {
  if (str?.length) {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array(numChunks);

    for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
      chunks[i] = str.substr(o, size);
    }

    return chunks;
  }

  return [];
};

export const formatCurrencyAmount = (
  amount: string | number,
  currency?: string
) => {
  return Number(amount).toLocaleString("en-US", {
    ...(currency ? { style: "currency", currency } : {}),
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const formatErrorMessage = (e) => {
  switch (e?.response?.status) {
    case 404:
      return "This payment link seems to be incomplete or wrong. Please check again.";
    case 500 || 502:
      return "There has been an error resolving this payment link.";
    default:
      return "An error occurred while processing this payment. Please try again.";
  }
};

export const getAPIErrorMessage = (e) => {
  return (
    e?.response?.data?.data?.gateway_response ||
    (Array.isArray(e?.response?.data?.message)
      ? e?.response?.data?.message[0]
      : e?.response?.data?.message || e.message)
  );
};

export const handleOutgoing = (
  type: "success" | "close" | "failed",
  payment,
  delay = 3000
) => {
  const { redirectUrl } = payment;
  const info = JSON.stringify({ result: type, data: payment });

  console.log("[postMessage]: ", type);
  window.parent.postMessage(info, "*");

  switch (type) {
    case "success": {
      if (redirectUrl) {
        setTimeout(() => {
          window.location.href = `${redirectUrl}?reference=${payment?.merchantReference}`;
        }, delay);
      }
      break;
    }
    case "close": {
      if (window.top == window.self) {
        window.location.href = `about:blank`;
      }
      return;
    }
  }
};

export const getInitials = (name) => {
  const splitName = name?.split(" ");
  if (!name) {
    return "";
  } else if (splitName.length === 1) {
    return `${splitName[0][0]}${splitName[0][1]}`.toUpperCase();
  } else {
    return `${splitName[0][0]}${splitName[1][0]}`.toUpperCase();
  }
};

export const addSlashes = (value: string) => {
  return value
    .replace(
      /^([1-9]\/|[2-9])$/g,
      "0$1/" // 3 > 03/
    )
    .replace(
      /^(0[1-9]|1[0-2])$/g,
      "$1/" // 11 > 11/
    )
    .replace(
      /^([0-1])([3-9])$/g,
      "0$1/$2" // 13 > 01/3
    )
    .replace(
      /^(0?[1-9]|1[0-2])([0-9]{2})$/g,
      "$1/$2" // 141 > 01/41
    )
    .replace(
      /^([0]+)\/|[0]+$/g,
      "0" // 0/ > 0 and 00 > 0
    )
    .replace(
      /[^\d\/]|^[\/]*$/g,
      "" // To allow only digits and `/`
    )
    .replace(
      /\/\//g,
      "/" // Prevent entering more than 1 `/`
    );
};

export function removeNonDigit(value) {
  return value.replace(/[^\d ]/g, "");
}

export function formatCardNumber(value) {
  return removeNonDigit(
    value.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ")
  ).trim();
}

export const capitalizeFirstLetter = (string) => {
  return string && string[0].toUpperCase() + string.slice(1);
};

export const capitalizeWords = (string = "", delimiter = " ") => {
  let splitStrings = string.split(delimiter);
  return splitStrings.map((string) => capitalizeFirstLetter(string)).join(" ");
};

export const formatDate = (date, locale = "en-GB") => {
  return new Date(date).toLocaleString(locale);
};

export const handleAuthModelStage = (auth_model: AuthModel) => {
  let stage;

  switch (auth_model) {
    case AuthModel.NO_AUTH:
      stage = PaymentStage.success;
      break;
    case AuthModel.PIN:
      stage = PaymentStage.auth_pin;
      break;
    case AuthModel.OTP:
      stage = PaymentStage.auth_otp;
      break;
    case AuthModel["3DS"]:
      stage = PaymentStage.auth_threeds;
      break;
    case AuthModel.CARD_ENROLL:
      stage = PaymentStage.card_enroll;
      break;
    case AuthModel.AVS:
      stage = PaymentStage.avs;
      break;
    case AuthModel.BIRTHDAY:
      stage = PaymentStage.auth_dob;
      break;
    case AuthModel.PHONE:
      stage = PaymentStage.card_enroll;
      break;
    default:
      stage = PaymentStage.init;
      break;
  }

  return stage;
};

export const getCheckoutSettings = () => {
  const business = cookie.get("business") || "{}";
  const businessObj = JSON.parse(business);
  return (
    businessObj?.checkoutSettings || {
      useBrandLogo: false,
      fontFamily: null,
      fontColor: null,
      buttonColor: null,
      buttonTextColor: null,
      backgroundColor: null,
      backgroundTextColor: null,
    }
  );
};

